const fb = window.firebase;

fb.initializeApp({
  apiKey: "AIzaSyA2rnViLZzdTnlrMd2sxrIY8hSc294dLbk",
  authDomain: "edutech-267418.firebaseapp.com",
  databaseURL: "https://edutech-267418.firebaseio.com",
  projectId: "edutech-267418",
  storageBucket: "edutech-267418.appspot.com",
  messagingSenderId: "103337734363",
  appId: "1:103337734363:web:c17d73fd9e535f7dc0dcfe",
  measurementId: "G-2E9ZXYB7X4"
});

fb.analytics();

export const firebase = fb;
